import fetchAPI from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import store from '../store';
import { enqueueSnackbar } from './snackbar';
import { modifyMetricData } from '../../utils/getMetrics';

function generateRandom() {
  const length = 24;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let retVal = '';
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export const listObservation = (wellId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.OBSERVATION_LIST_LOADING,
  });
  const body = {
    query: {
      wellsInfoId: wellId
    }
  };
  return fetchAPI
    .post('wells/entity/observationPoints/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      const { currentUser } = store.getState();
      const currentUnit = currentUser?.preferences?.unitSystem;
      const { data: targetData, units } = data;
      const modifiedTargetData = modifyMetricData(targetData, units, currentUnit);
      dispatch({
        type: REDUX_ACTIONS.OBSERVATION_LIST_SUCCESS,
        payload: {
          ...data,
          data: modifiedTargetData,
          paginatedElements: modifiedTargetData.length,
          units: data.units
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.OBSERVATION_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const addNewObservationRow = () => (dispatch) => {
  const { observation } = store.getState();
  const newObservation = [...observation.data];
  const existUnit = { ...observation.units };
  const nextId = newObservation.length - 1;
  const newRow = {
    name: '',
    depth: '',
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true
  };
  newObservation.unshift(newRow);
  dispatch({
    type: REDUX_ACTIONS.OBSERVATION_LIST_SUCCESS,
    payload: {
      data: newObservation,
      units: existUnit,
      paginatedElements: newObservation.length,
    },
  });
};

export const createObservation = (body, wellId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.OBSERVATION_LIST_LOADING,
  });
  const input = {
    query: {
      wellsInfoId: wellId
    },
    input: {
      ...body,
    }
  };
  return fetchAPI
    .post('wells/entity/observationPoints/create', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Observation Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listObservation(wellId));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listObservation(wellId));
    });
};

export const updateObservation = (body, wellId, rowId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.OBSERVATION_LIST_LOADING,
  });
  const input = {
    query: {
      _id: rowId,
      wellsInfoId: wellId
    },
    input: {
      ...body
    }
  };
  return fetchAPI
    .put('wells/entity/observationPoints', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Observation Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listObservation(wellId));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listObservation(wellId));
    });
};

export const deleteObservationRow = (deleteObservationId, wellId) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.OBSERVATION_LIST_LOADING,
  });
  const body = {
    query: {
      _id: deleteObservationId,
      wellsInfoId: wellId
    }
  };
  return fetchAPI
    .deleteAction('wells/entity/observationPoints', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Observation Deleted Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(listObservation(wellId));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(listObservation(wellId));
    });
};
